/*============Slider Controller
================================*/
angular
  .module('vppApp')
  .controller('sliderController', sliderController);

sliderController.$inject = ['$rootScope', '$scope', '$stateParams', 'vppConfig', 'sliderFactory', 'apiFactory', '$timeout', '$interval', '$filter', 'VarientService', 'SetLiveSwapService', 'ProgramInfoService'];

function sliderController($rootScope, $scope, $stateParams, vppConfig, sliderFactory, apiFactory, $timeout, $interval, $filter, VarientService, SetLiveSwapService, ProgramInfoService) {
  $scope.siteName = vppConfig.siteNames[vppConfig.folderPath];
  var firstClones = [],
    lastClones = [],
    initialPosition,
    _sliderContainer,
    _sliderStripContainer,
    _sliderThumbsContainer,
    _sliderThumbs,
    _sliderArrows,
    _sliderAmount,
    _sliderMathBox,
    _sliderMastheadImage,
    programCode,
    _sliderOverflow = false,
    prevPercent = 0,
    animTime = 1000;
  var exlcudedProgramIds = vppConfig.exlcudedProgramIds;
  $scope.varientName = VarientService.getVarientName();
  // console.log('sliderControl ', $scope.varientName);
  $rootScope.disclaimerEndDate = vppConfig.disclaimerEndDate;
  $scope.sliderActive = false;

  var classes = {
    'sliderContainer': 'slider-container',
    'sliderStripContainer': 'slider-thumbs-container',
    'sliderThumbsContainer': 'slider-thumbs',
    'sliderThumb': 'slider-thumb',
    'sliderArrows': 'slider-arrow',
    'reset': 'slider-resetting',
    'active': 'slider-active',
    'featured': 'slider-thumb-featured',
    'cloned': 'slider-thumb-clone',
    'mastheadImage': 'slider-masthead-image',
    'thumbCentered': 'slider-thumbs-centered',
    'mathBox': 'slider-masthead-content',
    'animate': 'animate'
  }

  var slideLength = {
    "small": 2,
    "medium": 4,
    "large": 4
  }
  /* get last 2 digits of current year */
  var d = new Date().getFullYear().toString().substr(-2);
  /* check for programCode if logged in */
  if ($rootScope.isAuth === true) {
    programCode = ProgramInfoService.getProgramCode().toLowerCase();
  }
  /*
   * check for varient or programCode of soty + current year
   * assign soty to programCode variable
   */

   // commented 8/28/20 for 2019 SOTY.
   //Request was to not pull SOTY pricing into the slider masthead
   // - BPR
  // if ($scope.varientName === "soty" || programCode === 'soty' + d) {
  //   programCode = "soty";
  // }

  function resizeThumbs() {
    var _containerWidth = _sliderStripContainer.offsetWidth;
    if (_sliderThumbs.length <= 0) _sliderThumbs = document.getElementsByClassName(classes.sliderThumb);

    var prev = _sliderAmount;

    switch (true) {
      case $rootScope.small:
        _sliderAmount = slideLength.small;
        break;
      case $rootScope.medium:
        _sliderAmount = slideLength.medium;
        break;
      case $rootScope.large:
        _sliderAmount = slideLength.large;
        break;
    }

    // set thumb width
    for (var i = 0; i < _sliderThumbs.length; i++) {
      _sliderThumbs[i].style.width = _containerWidth / _sliderAmount + 'px';
    }

    // set slider functionality init boolean
    _sliderOverflow = _sliderAmount < _sliderThumbs.length;

    // set slider width based on number of thumbs
    if (_sliderOverflow) {
      var length = (_sliderThumbs.length * _sliderThumbs[0].offsetWidth) + 100;
      _sliderThumbsContainer.style.width = length + 'px';
    } else {
      _sliderArrows[0].classList.add('hidden');
      _sliderArrows[1].classList.add('hidden');
    }

    // set slider height based on thumb height
    _sliderThumbsContainer.style.height = _sliderThumbs[0].offsetHeight + 30 + 'px';

    if (_sliderAmount && _sliderAmount !== prev) {
      var diff = _sliderAmount - prev;
      var elements = getSliderElements();
      var thumbs = Array.prototype.slice.call(getSliderElements().sliderThumbs);

      for (var i = 0; i < Math.abs(diff); i++) {
        if (diff < 0) {
          elements.activeElements[i].classList.remove(classes.active);
          moveNextImage(undefined, false);
        } else {
          var firstActive = thumbs.indexOf(elements.firstActive);
          var lastActive = thumbs.indexOf(elements.lastActive);

          if (i % 2 === 0) {
            elements.sliderThumbs[lastActive + 1].classList.add(classes.active);
            moveNextImage(undefined, true);
          } else {
            elements.sliderThumbs[firstActive - 2].classList.add(classes.active);
            moveNextImage(undefined, false);
          }
        }
      }

      // appendDups();
    }

  }


  function setSlider() {
    var _sliderThumbs = _sliderThumbsContainer.getElementsByClassName(classes.sliderThumb);
    // var length = Math.floor(_sliderThumbs.length - 1); // -1 bad maybe?

    // var dupAmount = _sliderAmount % 2 === 0 ? _sliderAmount + 1 : _sliderAmount;
    for (var i = 0; i < _sliderThumbs.length; i++) {
      createDups(i); //creates the duplicate vehicles
    }

    appendDups(); //adds the duplicate vehicles to the beginning and end of list in appropriate order

    //the below adds an additional copy of the last item, likely in an attempt to do what we're trying to
    // var firstNum = _sliderThumbs[0].getAttribute('data-slider-index') === _sliderThumbs[_sliderThumbs.length - 1].getAttribute('data-slider-index');
    // // firstNum, Boolean, the first and last slider indices are identical
    // while (!firstNum) { //initiates if indices are not identical, continues if they are identical
    //   createFirstDup(); //appends child to end with index-1 of first entry
    //   var _sliderThumbs = _sliderThumbsContainer.getElementsByClassName(classes.sliderThumb);
    //   var firstNum = _sliderThumbs[0].getAttribute('data-slider-index') !== _sliderThumbs[_sliderThumbs.length - 1].getAttribute('data-slider-index');
    // }

    var _sliderThumbs = _sliderThumbsContainer.getElementsByClassName(classes.sliderThumb);
    var initialPosition = _sliderThumbsContainer.offsetLeft;

    //---------- HAMMER JS INIT ----------//
    // the horizontal pane scroller
    var outer = new HammerCarousel(document.querySelector(".slider-thumbs"), Hammer.DIRECTION_HORIZONTAL);

    // init hammer js drag functionality
    // Hammer.each(document.querySelectorAll(".slider-thumbs .slider-thumb"), function(container) {
    //   // setup the inner scroller
    //   var inner = new HammerCarousel(container, Hammer.DIRECTION_HORIZONTAL);

    //   // only recognize the inner pan when the outer is failing.
    //   // they both have a threshold of some px
    //   outer.hammer.get('pan').requireFailure(inner.hammer.get('pan'));
    // });

    // set overflow position
    _sliderThumbsContainer.style.left = -(_sliderThumbs[0].offsetWidth * 3) + 'px';
  }


  function initSlider() {
    // family first sitename
    if (domainAbbr === 'emp') $scope.siteName = 'Employee Discount';
    if (_sliderThumbs.length <= 0) _sliderThumbs = document.getElementsByClassName(classes.sliderThumb);

    // set sizes
    resizeThumbs();

    // set featured image
    var featured = document.querySelectorAll('[data-featured="true"]');

    if (!featured || featured.length <= 0) {
      featured = [document.querySelectorAll('.slider-thumb')[0]];
    }

    for (var i = 0; i < featured.length; i++) {

      if (featured[i].className.indexOf(classes.cloned) < 0 || featured.length === 1) {
        var featuredEvent = {
          "target": featured[i]
        };
        setPosition();
        activeHandling();
        _sliderThumbsContainer.classList.remove(classes.reset);
        moveSliderClick(featuredEvent);
        mathBoxSlide();
      }
    }


    $timeout(function() {
      _sliderContainer.classList.add('loaded');
      resizeThumbs();
    }, 2000);
    $scope.$on(
      "$destroy",
      function(event) {
        $timeout.cancel();
      }
    );
  }


  function addEvents() {
    // add event listeners
    _sliderArrows[0].addEventListener('click', function(event) {
      $interval.cancel(autoPlay);
      moveSliderClick(event);
    }); // left arrow

    _sliderArrows[1].addEventListener('click', function(event) {
      $interval.cancel(autoPlay);
      moveSliderClick(event);
    }); // right arrow

    _sliderThumbsContainer.addEventListener('click', function(event) {
      $interval.cancel(autoPlay);
      moveSliderClick(event);
    }); // thumbs

    var autoPlay = $interval(function() {
      if (_sliderThumbs.length > _sliderAmount) {
        moveSliderClick();
      }
    }, 5000);
    $scope.$on(
      "$destroy",
      function(event) {
        $interval.cancel(autoPlay);
      }
    );
  }


  function createDups(i) {
    var elements = getSliderElements();

    var lastNum = parseInt(elements.lastElement.getAttribute('data-slider-index')) - i;
    var lastElem = elements.sliderThumbsContainer.querySelector('[data-slider-index="' + lastNum + '"]');


    var firstNum = parseInt(elements.firstElement.getAttribute('data-slider-index')) + i;
    var firstElem = elements.sliderThumbsContainer.querySelector('[data-slider-index="' + firstNum + '"]');

    var firstClone = firstElem.cloneNode(true);
    var lastClone = lastElem.cloneNode(true);

    firstClones.push(firstClone)
    lastClones.push(lastClone)
  }


  // function createFirstDup() {
  //   var elements = getSliderElements();

  //   var firstNum = parseInt(elements.firstElement.getAttribute('data-slider-index')) - 1;
  //   var firstElem = elements.sliderThumbsContainer.querySelector('[data-slider-index="' + firstNum + '"]');

  //   var firstClone = firstElem.cloneNode(true);

  //   elements.sliderThumbsContainer.appendChild(firstClone);
  //   firstClone.classList.add('slider-thumb-clone');
  //   firstClone.classList.remove(classes.active);
  //   firstClone.classList.remove(classes.featured);
  // }


  function appendDups() {
    var elements = getSliderElements();
    for (var i = 0; i < firstClones.length; i++) {
      elements.sliderThumbsContainer.appendChild(firstClones[i]);
      firstClones[i].classList.add('slider-thumb-clone');
      firstClones[i].classList.remove(classes.active);
    }

    for (var i = 0; i < lastClones.length; i++) {
      var elements = getSliderElements();
      elements.sliderThumbsContainer.insertBefore(lastClones[i], elements.firstElement);
      lastClones[i].classList.add('slider-thumb-clone');
      lastClones[i].classList.remove(classes.active);
    }



    firstClones = [];
    lastClones = [];
  }


  function moveSliderClick(event) {
    if (event && event.target.className.indexOf(classes.sliderThumbsContainer) > -1) return;
    if (_sliderOverflow) {
      var elements = getSliderElements();
      var dragging = elements.sliderThumbsContainer.className.indexOf(classes.reset) > -1;
      if (dragging) return;
      var thumbs = elements.activeElements;

      if (!event) {
        var isRight = true;
      } else {
        var isImage = event.target.className.indexOf(classes.sliderThumb) > -1;
        var isArrow = event.target.className.indexOf(classes.sliderArrows) > -1;
        var isRight = event.target.className.indexOf('right') > -1;
      }

      var numberToMove = 1;

      if (isImage) {
        var image = event.target;
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i] === image) {
            numberToMove = Math.abs(i - thumbs.length) - 1;
            isRight = i > thumbs.length / 2;
            break;
          }
        }
      }

      for (var i = 0; i < numberToMove; i++) {
        var elements = getSliderElements();
        if (!isRight) {
          elements.lastActive.classList.remove(classes.active);
          elements.firstActive.previousElementSibling.classList.add(classes.active);
        } else {
          elements.firstActive.classList.remove(classes.active);
          elements.lastActive.nextElementSibling.classList.add(classes.active);
        }

        moveNextImage(undefined, isRight);
      }
    }

    $timeout(function() {
      if (event && event.target.className.indexOf(classes.sliderThumb) > -1) {
        var newImage = event.target;
      } else {
        var newImage = undefined;
      }

      // check if selected image is already shown
      var currentImage = _sliderMastheadImage.getAttribute('src');
      if (newImage && newImage.getAttribute('data-featured-img') === currentImage) return;

      _sliderThumbsContainer.classList.add(classes.reset);

      setPosition(function() {
        $timeout(function() {
          _sliderThumbsContainer.classList.remove(classes.reset);
        }, animTime);
      });

      featuredImageHandler(newImage);
      mathBoxSlide();
    }, 200);

    $scope.$on(
      "$destroy",
      function(event) {
        $timeout.cancel();
      }
    );
  }


  function moveNextImage(elements, rightArrow) {
    var elements = getSliderElements();
    elements.sliderThumbsContainer.classList.remove(classes.reset);

    if (elements.lastElement.getAttribute('data-slider-index') === elements.firstElement.getAttribute('data-slider-index')) {
      if (rightArrow) {
        var nextElem = elements.sliderThumbs[1];
        var newElem = elements.firstElement;
      } else {

        var nextElem = elements.sliderThumbs[elements.sliderThumbs.length - 2];
        var newElem = elements.lastElement;
      }

      newElem.className = nextElem.className;
      newElem.setAttribute('data-slider-index', nextElem.getAttribute('data-slider-index'));
      newElem.setAttribute('src', nextElem.getAttribute('src'));
    }

    if (rightArrow) {
      elements.sliderThumbsContainer.appendChild(elements.firstElement);
      setTransform(elements.firstElement, elements.sliderThumbsContainer.getBoundingClientRect().width);
    } else {
      elements.sliderThumbsContainer.insertBefore(elements.lastElement, elements.firstElement);
      setTransform(elements.lastElement, 0);
    }
  }

  function featuredImageHandler(newFeatured, event) {
    // this function will set the selected image with the featured class
    // and set the masthead image with animation
    var elements = getSliderElements();
    var shownLength = Math.round(elements.activeElements.length - 1);
    if (!newFeatured) var newFeatured = elements.activeElements[shownLength];
    var source = newFeatured.getAttribute('data-featured-img');

    if (elements.featuredImage)
      elements.featuredImage.classList.remove(classes.featured);

    newFeatured.classList.add(classes.featured);

    // set variables for mathbox
    var newID = newFeatured.getAttribute('data-thumb-id');
    $scope.sliderFeatured = $scope.sliderItemsDetail[newID];
    $scope.sliderFeatured.active = true;

    if ($scope.sliderFeatured) {
      var consumerCash = [];
      var bonusCash = [];
      var allowanceCash = [];
      if (newFeatured.getAttribute('data-title').length > 0) $scope.sliderFeatured.title = newFeatured.getAttribute('data-title');
      $scope.sliderFeatured.make = newFeatured.getAttribute('data-make') ? newFeatured.getAttribute('data-make') : $scope.sliderFeatured.vehicleDetails.make;
      $scope.sliderFeatured.model = newFeatured.getAttribute('data-model') ? newFeatured.getAttribute('data-model') : $scope.sliderFeatured.vehicleDetails.model;

      if($scope.sliderFeatured.vehicleDetails.make.toLowerCase() == 'cadillac'){
        if($rootScope.siteCode === 'gmed' || $rootScope.siteCode === 'cgp'){
          $scope.brandLogo = $scope.sliderFeatured.vehicleDetails.make;

        } else {
          $scope.brandLogo = $scope.sliderFeatured.vehicleDetails.make+"_new";
        }

      } else {
        $scope.brandLogo = $scope.sliderFeatured.vehicleDetails.make;

      }

      if ($scope.brandLogo !== "GMC") {
        var titleFilter = $filter('titleCase');
        titleFilter($scope.brandLogo);
      };

      for (var i = 0; i < Object.keys($scope.sliderFeatured.cashValues.details).length; i++) {
        var k = Object.keys($scope.sliderFeatured.cashValues.details)[i],
            date = $scope.programDetails[k].endDate;
        date = date.substr(5) + "/" + date.substr(0, 4),
            $scope.currentProgramType = $scope.programDetails[k].programType;
        var programId = $scope.programDetails[k].id;
        exlcudedProgramIds.indexOf(programId) < 0 && "0.0" !== $scope.sliderFeatured.cashValues.details[k].cash && ("CONSUMER CASH" === $scope.programDetails[k].programType.toUpperCase() ? (console.log($rootScope.consumerCashEndDate),
                $rootScope.consumerCashEndDate = date,
                $scope.consumerCode = k,
                consumerCash.push(parseInt($scope.sliderFeatured.cashValues.details[k].cash))) : "BONUS CASH" === $scope.programDetails[k].programType.toUpperCase() ? ($rootScope.bonusCashEndDate = date,
                $scope.bonusCode = k,
                bonusCash.push(parseInt($scope.sliderFeatured.cashValues.details[k].cash))) : "EMPLOYEE VEHICLE ALLOWANCE" === $scope.programDetails[k].programType.toUpperCase() && ($rootScope.allowanceCashEndDate = date,
                $scope.allowanceCode = k,
                allowanceCash.push(parseInt($scope.sliderFeatured.cashValues.details[k].cash)))),
            $scope.combinedConsumer = consumerCash.reduce(function (a, b) {
                return a + b
            }, 0),
            $scope.combinedBonus = bonusCash.reduce(function (a, b) {
                return a + b
            }, 0),
            $scope.combineAllowance = allowanceCash.reduce(function (a, b) {
                return a + b
            }, 0)
    }
      /* ===== if both cash allowance and bonus cash exist take the earlier date ====== */
      if (allowanceCash.length > 0 && bonusCash.length < 1) {
        $rootScope.bonusCashEndDate = $rootScope.allowanceCashEndDate;
      } else if (allowanceCash.length > 0 && bonusCash.length > 0) {
        var allowanceCashEndDate = $rootScope.allowanceCashEndDate;
        var bonusCashEndDate = $rootScope.bonusCashEndDate;
        allowanceCashEndDate = new Date(allowanceCashEndDate);
        bonusCashEndDate = new Date(bonusCashEndDate);
        if (allowanceCashEndDate < bonusCashEndDate) {
          $rootScope.bonusCashEndDate = $rootScope.allowanceCashEndDate;
        } else {
          $rootScope.bonusCashEndDate = $rootScope.bonusCashEndDate;
        }

      } else if (allowanceCash.length < 1 && bonusCash.length > 0) {
        $rootScope.bonusCashEndDate = $rootScope.bonusCashEndDate;
      }

      /*======= check for endDates take the earlier date of consumer and bonus cash/ create new variable for total discount end date =========*/
      if (allowanceCash.length < 1 && bonusCash.length < 1 && (consumerCash[0] === 0 || consumerCash.length < 1)) {
        $rootScope.totalDiscountEndDate = $rootScope.disclaimerEndDate;
      } else if ($rootScope.bonusCashEndDate && !$rootScope.consumerCashEndDate) {
        $rootScope.totalDiscountEndDate = $rootScope.bonusCashEndDate;
      } else if (!$rootScope.bonusCashEndDate && $rootScope.consumerCashEndDate) {
        $rootScope.totalDiscountEndDate = $rootScope.consumerCashEndDate;
      } else if ($rootScope.bonusCashEndDate && $rootScope.consumerCashEndDate) {
        if ($rootScope.bonusCashEndDate < $rootScope.consumerCashEndDate) {
          $rootScope.totalDiscountEndDate = $rootScope.bonusCashEndDate;
        } else {
          $rootScope.totalDiscountEndDate = $rootScope.consumerCashEndDate;
        }
      }



      var bonus = $scope.combinedBonus ? $scope.combinedBonus : 0;
      var consumer = $scope.combinedConsumer ? $scope.combinedConsumer : 0;
      var allowance = $scope.combineAllowance ? $scope.combineAllowance : 0;


      // pulling in supplier pricing for 2019 SOTY - BPR 8/28/20
      // if ($rootScope.siteCode === 'emp' ||
      //   $rootScope.siteCode === 'ded' || ($rootScope.siteCode === 'sup' && programCode === 'soty')) {
      if ($rootScope.siteCode === 'emp' || $rootScope.siteCode === 'ded') {
        $scope.sitePricing = $scope.sliderFeatured.pricingDetails.employeePricing.price;
        var combined = ($scope.sliderFeatured.pricingDetails.totalConfigMsrp.price - $scope.sliderFeatured.pricingDetails.employeePricing.price) + bonus + consumer + allowance;
        var total = $scope.sliderFeatured.pricingDetails.employeePricing.price - bonus - consumer - allowance;
      } else {
        $scope.sitePricing = $scope.sliderFeatured.pricingDetails.supplierPricing.price;
        var combined = ($scope.sliderFeatured.pricingDetails.totalConfigMsrp.price - $scope.sliderFeatured.pricingDetails.supplierPricing.price) + bonus + consumer + allowance;
        var total = $scope.sliderFeatured.pricingDetails.supplierPricing.price - bonus - consumer - allowance;
      }

      $scope.sliderFeatured.total = total;
      if (bonus > 0) $scope.sliderFeatured.bonus = bonus;
      if (consumer > 0) $scope.sliderFeatured.consumer = consumer;
      if (allowance > 0) $scope.sliderFeatured.allowance = allowance;
      if (combined > 0) $scope.sliderFeatured.combined = combined;
    } else if (!$scope.sliderFeatured) {
      var id = newFeatured.getAttribute('data-thumb-id');

      for (var i = 0; i < $scope.sliderItems.length; i++) {
        if (id === $scope.sliderItems[i].styleID) {
          $scope.sliderFeatured = $scope.sliderItems[i];

          if (newFeatured.getAttribute('data-title').length > 0) $scope.sliderFeatured.title = newFeatured.getAttribute('data-title');
        }
      }
    }

    // don't show animation if resizing
    if (!event || event.type !== 'resize') {
      _sliderMastheadImage.style.opacity = 0;
      _sliderMastheadImage.style.width = '';
      $timeout(function() {
        if (!$scope.sliderFeatured) {
          _sliderMastheadImage.style.width = Math.round(document.documentElement.clientWidth * .99) + 'px';
        } else {
          _sliderMastheadImage.style.width = '';
        }
        var img = new Image();
        img.onload = function() {
          _sliderMastheadImage.setAttribute('src', source);
          _sliderMastheadImage.style.opacity = 1;
        }
        img.src = source;
      }, 1000);
      $scope.$on(
        "$destroy",
        function(event) {
          $timeout.cancel();
        }
      );
    } else {
      _sliderMastheadImage.setAttribute('src', source);
    }
  }

  function mathBoxSlide() {
    _sliderMathBox.classList.add(classes.animate);
    $timeout(function() {
      $scope.$apply();
      _sliderMathBox.classList.remove(classes.animate);
    }, 1000);
    $scope.$on(
      "$destroy",
      function(event) {
        $timeout.cancel();
      }
    );
  }

  function setPosition(callback) {
    // this function will reset the position of the thumbs
    if (_sliderOverflow) {
      var paneIndex, pos, translate;
      var thumbs = Array.prototype.slice.call(getSliderElements().sliderThumbs);
      var container = getSliderElements().sliderThumbsContainer;

      for (paneIndex = 0; paneIndex < thumbs.length; paneIndex++) {
        var width = thumbs[paneIndex].offsetWidth;
        var firstActive = thumbs.indexOf(getSliderElements().firstActive);
        var left = Math.abs(container.offsetLeft) + getSliderElements().sliderContainer.offsetLeft;
        // pos = ((paneIndex - firstActive) * width) + Math.abs(container.offsetLeft);
        pos = ((paneIndex - firstActive) * width) + Math.abs(container.offsetLeft);

        setTransform(thumbs[paneIndex], pos);
      }
    } else {
      _sliderThumbsContainer.classList.add(classes.thumbCentered);
    }

    if (typeof callback === 'function') {
      callback();
    }
  }

  function activeHandling(event) {
    // this function will set the active class on images in viewable area
    var elements = getSliderElements();
    var newActiveLength = 0;

    for (var i = 0; i < elements.sliderThumbs.length; i++) {
      var half = elements.sliderThumbs[0].getBoundingClientRect().width / 2;
      var containerLeft = _sliderStripContainer.getBoundingClientRect().left - half;
      var thumbPos = elements.sliderThumbs[i].getBoundingClientRect().left + 10;
      var containerWidth = _sliderStripContainer.getBoundingClientRect().width + containerLeft;

      // check if slider element is in viewable area
      if (thumbPos > containerLeft && thumbPos < containerWidth && newActiveLength < _sliderAmount) {
        elements.sliderThumbs[i].classList.add(classes.active);
        newActiveLength++;
      } else {
        elements.sliderThumbs[i].classList.remove(classes.active);
      }
    }

    // get elements now that their classes have changed
    var elements = getSliderElements();

    featuredImageHandler(undefined, event);
    // do not show animations if resizing browser
    if (!event || (event && event.type !== 'resize')) {
      mathBoxSlide();
    }

    // reset position once all have been moved
    elements.sliderThumbsContainer.classList.add(classes.reset);
    setPosition(function() {
      $timeout(function() {
        elements.sliderThumbsContainer.classList.remove(classes.reset);
      }, animTime);
      $scope.$on(
        "$destroy",
        function(event) {
          $timeout.cancel();
        }
      );
    });
  }


  function setTransform(thumb, amount) {
    // this function will move the thumb to its correct position
    var translate = 'translate3d(' + amount + 'px, 0, 0)';

    thumb.style.transform = translate;
    thumb.style.mozTransform = translate;
    thumb.style.webkitTransform = translate;
  }


  function checkIfData() {

  }

  //---------------------------------------------------//
  //-------------------- Hammer js --------------------//
  //---------------------------------------------------//

  var reqAnimationFrame = (function() {
    return window[Hammer.prefixed(window, "requestAnimationFrame")] || function(callback) {
      $timeout(callback, 1000 / 60);
    }
    $scope.$on(
      "$destroy",
      function(event) {
        $timeout.cancel();
      }
    );
  })();

  function dirProp(direction, hProp, vProp) {
    return (direction & Hammer.DIRECTION_HORIZONTAL) ? hProp : vProp
  }

  /**
   * Carousel
   * @param container
   * @param direction
   * @constructor
   */
  function HammerCarousel(container, direction) {
    this.container = container;
    this.direction = direction;

    this.panes = Array.prototype.slice.call(this.container.children, 0);
    this.containerSize = this.container[dirProp(direction, 'offsetWidth', 'offsetHeight')];

    this.currentIndex = 0;

    this.hammer = new Hammer.Manager(this.container);
    this.hammer.add(new Hammer.Pan({
      direction: this.direction,
      threshold: 10
    }));
    this.hammer.on("panstart panmove panend pancancel", Hammer.bindFn(this.onPan, this));

    this.show(this.currentIndex);
  }


  HammerCarousel.prototype = {
    /**
     * show a pane
     * @param {Number} showIndex
     * @param {Number} [percent] percentage visible
     * @param {Boolean} [animate]
     */
    show: function(showIndex, percent, animate, delta) {
      showIndex = Math.max(0, Math.min(showIndex, this.panes.length - 1));
      percent = percent || 0;

      var className = this.container.className;
      if (animate) {
        if (className.indexOf('animate') === -1) {
          this.container.className += ' animate';
        }
      } else {
        if (className.indexOf('animate') !== -1) {
          this.container.className = className.replace('animate', '').trim();
        }
      }

      var paneIndex, pos, translate;
      for (paneIndex = 0; paneIndex < this.panes.length; paneIndex++) {
        var parentLeft = this.panes[paneIndex].parentElement.getBoundingClientRect().left;
        var left = this.panes[paneIndex].getBoundingClientRect().left;

        // minus last total drag from current total drag
        if (paneIndex === 0) {
          if (!prevPercent) prevPercent = 0;
          prevPercent = delta - (prevPercent);
        }

        pos = (left - parentLeft) + prevPercent;
        setTransform(this.panes[paneIndex], pos);

        // set previous percent if last slider item
        if (paneIndex === this.panes.length - 1) {
          prevPercent = delta;
        }
      }

      this.currentIndex = showIndex;
    },

    /**
     * handle pan
     * @param {Object} ev
     */
    onPan: function(ev) {
      if (this.panes.length <= 0) this.panes = _sliderThumbs;
      var delta = dirProp(this.direction, ev.deltaX, ev.deltaY);
      var percent = (100 / this.containerSize) * delta;
      var animate = false;
      var width = this.panes[this.currentIndex].offsetWidth;
      var containerWidth = getSliderElements().sliderContainer.offsetWidth;
      getSliderElements().sliderThumbsContainer.classList.add('animating');

      if (ev.type == 'panend' || ev.type == 'pancancel') {
        // reset global slider variables
        prevPercent = 0;
        percent = 0;
        animate = true;

        // set math variables
        var firstLeft = this.panes[0].getBoundingClientRect().left;
        var lastLeft = this.panes[this.panes.length - 1].getBoundingClientRect().left - this.panes[0].offsetParent.getBoundingClientRect().left;
        var right = ev.deltaX < 0;

        // check if moved half a slider element or more, set amount
        if (Math.abs(ev.deltaX) >= (width / 2)) {
          var amount = Math.round(Math.abs(ev.deltaX) / width);
        }

        // set what slider element to move
        if (!right && ev.deltaX >= (width / 2)) {
          var num = 0;
        } else if (right && Math.abs(ev.deltaX) >= (width / 2)) {
          var num = getSliderElements().sliderThumbs.length - 1;
        }

        // move first or last items in slider to other side
        for (var i = 0; i < amount; i++) {
          moveNextImage(undefined, right);
          this.panes = getSliderElements().sliderThumbs;
        }

        // set active items and positions once done moving markup
        activeHandling();
      } else {
        this.show(this.currentIndex, percent, animate, delta);
      }
    }
  };

  //---------------------------------------------------//
  //------------------ End Hammer js ------------------//
  //---------------------------------------------------//

  function getSliderElements() {

    var sliderContainer = document.querySelector('.' + classes.sliderContainer);
    var sliderThumbsContainer = document.querySelector('.' + classes.sliderThumbsContainer);
    var sliderThumbs = sliderThumbsContainer.getElementsByClassName(classes.sliderThumb);
    var sliderClones = sliderThumbsContainer.getElementsByClassName(classes.cloned);

    var firstElement = sliderThumbs[0];
    var lastElement = sliderThumbs[sliderThumbs.length - 1];

    var activeElements = document.getElementsByClassName(classes.active);
    var firstActive = activeElements[0];
    var lastActive = activeElements[activeElements.length - 1];

    var featuredImage = sliderThumbsContainer.querySelector('.' + classes.featured);
    if (featuredImage) {
      var nextElement = featuredImage.nextElementSibling;
      var prevElement = featuredImage.previousElementSibling;
    };

    return {
      'sliderContainer': sliderContainer,
      'sliderThumbsContainer': sliderThumbsContainer,
      'sliderThumbs': sliderThumbs,
      'sliderClones': sliderClones,
      'firstElement': firstElement,
      'lastElement': lastElement,
      'activeElements': activeElements,
      'firstActive': firstActive,
      'lastActive': lastActive,
      'nextElement': nextElement,
      'prevElement': prevElement,
      'featuredImage': featuredImage
    }
  }

  sliderFactory().then(function(response) {
    var sliderItems = response.data.styles;
    $scope.sliderActive = response.data.active;
    var liveswap = SetLiveSwapService.getLSBrandName();
    var lsbrand = vppConfig.lsBrands[liveswap];
    var validSliders = [];
    var brandList = [];
    var vehicles = [];
    if (lsbrand) {
      var lsBrands = lsbrand;
      for (var i = 0; i < lsBrands.length; i++) {
        var thisBrand = lsBrands[i].toLowerCase();
        if (thisBrand === 'chevy') {
          thisBrand = 'chev';
        }
        brandList.push(thisBrand);
      }
    }

    function containsAny(str, substrings) {
      for (var i = 0; i < substrings.length; i++) {
        var substring = substrings[i];
        if (str.indexOf(substring) > -1) {
          return substring;
        }
      }
      return null;
    }

    for (var i = 0; i < Object.keys(sliderItems).length; i++) {
      var title = sliderItems[i].title;
      if (title) {
        title = title.toLowerCase();
      } else {
        title = '';
      }
      var match = containsAny(title, brandList);
      if (lsbrand && match && sliderItems[i].styleID) {
        vehicles.push(sliderItems[i]);
      } else if (!lsbrand && sliderItems[i].styleID) {
        vehicles.push(sliderItems[i]);

      }
    }

    apiFactory.mastheadSliderOptions(vehicles).then(function(response) {
      $scope.sliderItemsDetail = response.data.vehicles;
      $scope.programDetails = response.data.programDetails;
      var programTypes = [];

      var sliderContainer = document.querySelector('.' + classes.sliderContainer);

      // if(Object.keys($scope.sliderItemsDetail).length === 0){
      //   document.getElementsByClassName('slider-default-message')[0].classList.remove('hidden');
      //   sliderContainer.classList.add('loaded');
      //   sliderContainer.classList.add('hidden');
      //   return;
      // }

      for (var y = 0; y < Object.keys(vehicles).length; y++) {
        var s = Object.keys(vehicles)[y];
        var item = vehicles[s]['styleID'];

        if ($scope.sliderItemsDetail) {
          for (var i = 0; i < Object.keys($scope.sliderItemsDetail).length; i++) {
            var k = Object.keys($scope.sliderItemsDetail)[i];
            if (item === k || !item) {
              validSliders.push(vehicles[s]);
              break;
            }
          }
        }
      }

      for (var i = 0; i < Object.keys(sliderItems).length; i++) {
        if (!sliderItems[i].styleID) {
          sliderItems[i].styleID = sliderItems[i].id;
          validSliders.splice(i, 0, sliderItems[i]);
        }
      }

      $scope.sliderItems = validSliders;

      var sliderThumbs = sliderContainer.getElementsByClassName(classes.sliderThumb);
      for (var i = 0; i < sliderThumbs.length; i++) {
        sliderThumbs[i].setAttribute('data-slider-index', i)
      }
      if ($scope.programDetails) {
        for (var i = 0; i < Object.keys($scope.programDetails).length; i++) {
          var k = Object.keys($scope.programDetails)[i];
          var date = $scope.programDetails[k].endDate;
          date = date.substr(5) + '/' + date.substr(0, 4);

          $scope.currentProgramType = $scope.programDetails[k].programType;
          if ($scope.programDetails[k].id)
            if ($scope.programDetails[k].programType.toUpperCase() === 'CONSUMER CASH') {
              programTypes.push($scope.currentProgramType);
            } else if ($scope.programDetails[k].programType.toUpperCase() === 'BONUS CASH') {
            programTypes.push($scope.currentProgramType);
          } else if ($scope.programDetails[k].programType.toUpperCase() === 'EMPLOYEE VEHICLE ALLOWANCE') {
            programTypes.push($scope.currentProgramType);
          }
        }
        /*=== filter out duplicate programtypes ===*/
        $scope.uniqueProgamType = programTypes.unique();
        var bonusCash = $scope.uniqueProgamType.indexOf('Bonus Cash');
        if (bonusCash === -1) {
          $rootScope.consumerDiscNumber = 3;
        } else {
          $rootScope.consumerDiscNumber = 4;
        }
      }


      window.addEventListener('resize', function() {
        resizeThumbs();
        setPosition();
        activeHandling(event);
      });

      document.addEventListener('dragstart', function(e) {
        // fix for firefox not allowing images to be dragged
        if (e.target.className.indexOf(classes.sliderThumb) > -1 && e.target.nodeName.toUpperCase() === "IMG") {
          e.preventDefault();
        }
      });

      _sliderThumbs = document.getElementsByClassName(classes.sliderThumb);

      angular.element(document).ready(function() {
        _sliderContainer = document.querySelector('.' + classes.sliderContainer);
        _sliderStripContainer = _sliderContainer.querySelector('.' + classes.sliderStripContainer);
        _sliderThumbsContainer = document.querySelector('.' + classes.sliderThumbsContainer);

        _sliderArrows = _sliderContainer.getElementsByClassName(classes.sliderArrows);
        _sliderMathBox = _sliderContainer.querySelector('.' + classes.mathBox);
        _sliderMastheadImage = _sliderContainer.querySelector('.' + classes.mastheadImage);

        $timeout(function() {
          resizeThumbs();

          // init slider if more thumbs than container width
          if (_sliderOverflow) setSlider();

          addEvents();
          initSlider();
        });

      });

    });
  });

}
